import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
  options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className = '',
  error,
  options,
  placeholder,
  ...props
}, ref) => {
  return <div className="relative w-full" data-id="element-111">
        <select ref={ref} className={`
            appearance-none block w-full rounded-lg border shadow-sm py-2.5 pl-3 pr-10 text-gray-900 
            focus:ring-2 focus:ring-inset focus:ring-teal-600 sm:text-sm sm:leading-6
            disabled:bg-gray-50 disabled:text-gray-500
            ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300 focus:border-teal-600'}
            ${className}
          `} {...props} data-id="element-112">
          {placeholder && <option value="" disabled data-id="element-113">
              {placeholder}
            </option>}
          {options.map(opt => <option key={opt.value} value={opt.value} disabled={opt.disabled} data-id="element-114">
              {opt.label}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-115">
          <ChevronDown className="h-4 w-4" data-id="element-116" />
        </div>
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-117">{error}</p>}
      </div>;
});
Select.displayName = 'Select';